import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { messageBus } from '../infrastructure.js';
import { config } from '../config.js';

const clickHandler = event => {
  event.preventDefault();

  const expiresAt = new Date();
  expiresAt.setDate(expiresAt.getDate() + 30);
  const localStorageObject = {
    expiresAt,
  };
  localStorage.setItem('osk-b2b-accepted', JSON.stringify(localStorageObject));
  messageBus.publish('router', 'navigate', { path: config.basePath });
};

export default function renderB2bPageTemplate() {
  return html`
    <div class="section">
      <div class="container">
        <div class="grid">
          <div class="grid__col--md-6 hide-md mb-medium">
            <img class="img" src="assets/images/representation-clients.png" alt="" />
          </div>
          <div class="grid__col--md-6">
            <div class="grid">
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9">
                <h1 class="h2 mb-xlarge">
                  Dobrý deň,<br /><br />pre vašu spoločnosť máme ešte výhodnejšiu ponuku služieb ako
                  by ste našli v Môj Orange.
                </h1>
              </div>
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9 bold">
                <p class="large">
                  Kontaktujte prosím svojho osobného predajcu, ktorý vás prevedie nastavením služieb
                  na mieru.
                </p>
                <p class="large">
                  Môžete tiež zavolať na linku pre firemných zákazníkov
                  <a class="link" href="tel:+421908908908">0908 908 908</a>.
                </p>
                <p class="large">
                  Prípadne použite niektorú z našich biznis aplikácií (<a
                    class="link"
                    href="https://www.orange.sk/business/selfcare/kfs/default.dwp"
                    >Správa firemnej komunikácie</a
                  >,
                  <a
                    class="link"
                    href="https://monitoringvozidiel.orange.sk/portal/index.php?page=Login"
                    >Monitoring vozidiel</a
                  >, ...).
                </p>
              </div>
            </div>
            <a href="https://www.orange.sk/biznis/aplikacie" class="btn btn--primary"
              >Prejsť na Biznis aplikácie</a
            >
          </div>
          <div class="grid__col--md-6 show-md mb-medium">
            <img class="img-fluid" src="assets/images/representation-clients.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="grid">
          <div class="grid__col--md-6">
            <div class="grid">
              <div class="grid__col--sm-9 grid__col--md-10 grid__col--lg-9">
                <h2>Chcete napriek tomu navštíviť zákaznícku zónu Môj Orange?</h2>
              </div>
            </div>
            <a href=${config.basePath} @click=${clickHandler} class="btn"
              >Pokračovať na Môj Orange</a
            >
          </div>
        </div>
      </div>
    </div>
  `;
}
